import React, { useCallback, useEffect, forwardRef, useState } from "react";
import { ShowroomCarCard } from "./ShowroomCarCard/ShowroomCarCard";
import { Waiting } from "../../Components/System/Waiting";
import { VirtuosoGrid } from "react-virtuoso";
import { ShowroomCarView } from "../Showroom/ShowroomCarView";
import { Drawer } from "@mantine/core";
import { useCarListParameters } from "../../Hooks/useCarListParameters";
import { DirectionEnum } from "../../Enums/DirectionEnum";

export const Showroom = React.memo(({ selectedCar, cars, hidePrices, open, close, opened, equipmentBaseIcons, fnUpdateData }) => {
    const { setCarListParameters } = useCarListParameters();
    const [currentCarIndex, setCurrentCarIndex] = useState(null);

    const [activeCar, setActiveCar] = useState();
    const gridComponents = {
        List: forwardRef(({ style, children, ...props }, ref) => (
            <div
                ref={ref}
                {...props}
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    ...style,
                }}
            >
                {children}
            </div>
        )),
        Item: ({ children, ...props }) => (
            <div
                {...props}
                style={{
                    padding: "0.5rem",
                    display: "flex",
                    flex: "none",
                    alignContent: "stretch",
                    boxSizing: "border-box",
                }}
            >
                {children}
            </div>
        )
    }

    const ItemWrapper = ({ children, ...props }) => (
        <div
            {...props}
            style={{
                display: "flex",
                flex: 1,
                textAlign: "center",
                whiteSpace: "nowrap",
            }}
        >
            {children}
        </div>
    );

    const handleCarClicked = (car) => {
        if (car) {
            setCarListParameters({ carhash: car.hash });
            setActiveCar(car);
        } else {
            setCarListParameters({ carhash: null });
            setActiveCar(null);
        }
    };

    const changeCar = useCallback((direction) => {
        if (cars && currentCarIndex !== null && opened) {
            const count = cars.length;
            const newIndex =
                direction === DirectionEnum.next
                    ? (currentCarIndex + 1) % count
                    : (currentCarIndex - 1 + count) % count;

            handleCarClicked(cars[newIndex]);
        }
    }, [currentCarIndex, cars, opened, handleCarClicked]);

    useEffect(() => {
        if (activeCar && cars?.length) {
            const index = cars.findIndex(car => car.hash === activeCar.hash);
            setCurrentCarIndex(index);
            open();
        } else {
            close();
        }
    }, [activeCar]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleKeyDown = useCallback((e) => {
        if (!opened || currentCarIndex === null) return;

        if (e.key === 'ArrowRight') {
            changeCar(DirectionEnum.next);
        } else if (e.key === 'ArrowLeft') {
            changeCar(DirectionEnum.previous);
        }
    }, [opened, currentCarIndex, cars]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    if (cars) {
        return (
            <>
                <div className="">
                    <div style={{ height: '92vh' }}>
                        <VirtuosoGrid
                            style={{ height: '92vh', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}
                            data={cars}
                            components={gridComponents}
                            itemContent={(index, car) => (
                                <ItemWrapper><ShowroomCarCard key={"card_" + car.hash} car={car} hidePrices={hidePrices} fnCardClicked={handleCarClicked} equipmentBaseIcons={equipmentBaseIcons} fnAfterUpdate={fnUpdateData} /></ItemWrapper>
                            )}
                        />
                    </div>
                </div>
                <Drawer
                    position="right"
                    size="1100px"
                    padding="md"
                    opened={opened}
                    onClose={() => {
                        close();
                        handleCarClicked(null);
                    }}
                    withOverlay={true}
                    overlayProps={{
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
                    }}
                    withCloseButton={false}
                    lockScroll={true}
                    keepMounted={true}
                >
                    <ShowroomCarView car={activeCar} changeCar={changeCar} hidePrices={hidePrices} close={() => { close(); handleCarClicked(null); }} equipmentBaseIcons={equipmentBaseIcons} fnUpdateData={fnUpdateData} />
                </Drawer>
            </>
        )
    } else {
        return (
            <Waiting />
        )
    }

});